import React from 'react';
import clsx from 'clsx';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { makeStyles } from '@material-ui/core';
// a little function to help us with reordering the result
const reorder = (list: any, startIndex: any, endIndex: any) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
};
const useStyles = makeStyles((theme) => ({
    list: {
        padding: theme.spacing(1),
        width: 250,
    },
    listItem: {
        // some basic styles to make the items look a bit nicer
        userSelect: 'none',
        margin: `0 0 ${theme.spacing(1)}px 0`,
    }
}));

const OrderableList = ({ options, setOptions, selectedOptionIds, onChange, listClassName, listItemClassName }: any) => {
    const classes = useStyles();
    const onDragEnd = (result: any) => {
        // dropped outside the list
        if (!result.destination) {
            return;
        }
        const _options = reorder(options, result.source.index, result.destination.index);
        setOptions(_options);
        const reordered = _options
            .filter((option) => selectedOptionIds.includes((option as any).id))
            .map((option) => (option as any).id);
        onChange(reordered);
    };
    const onCheck = (optionId: any, isChecked: any) => {
        let newSelectedOptionIds: any;
        if (isChecked) {
            newSelectedOptionIds = [...selectedOptionIds, optionId];
        }
        else {
            newSelectedOptionIds = selectedOptionIds.filter((_optionId: any) => _optionId !== optionId);
        }
        const reordered = options
            .filter((option: any) => newSelectedOptionIds.includes(option.id))
            .map((option: any) => option.id);
        onChange(reordered);
    };
    return (<DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable">
        {(provided: any, snapshot: any) => (<div {...provided.droppableProps} ref={provided.innerRef} className={clsx(classes.list, listClassName)}>
            {options.map((item: any, index: any) => (<Draggable key={item.id} draggableId={item.id} index={index}>
                {(provided: any, snapshot: any) => (<div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} 
    // style={provided.draggableProps.style}
    className={clsx(classes.listItem, listItemClassName)}>
                    <item.content isSelected={selectedOptionIds.includes(item.id)} onChange={onCheck}/>
                  </div>)}
              </Draggable>))}
            {provided.placeholder}
          </div>)}
      </Droppable>
    </DragDropContext>);
};
export default OrderableList;
